import { useState, useEffect } from "react";
import { useCheckoutPricing as useRecurlyCheckoutPricing } from "@recurly/react-recurly";
import { getRecurlyPlan } from "./get-recurly-plan";
import { getRecurlyAddons } from "./get-recurly-addons";
import { AccountSubscriptionPaidConfig } from "~utils/types/__generated/gql/graphql";
import { RecurlyError, Address } from "@recurly/recurly-js";
import { toast } from "~ui-components/components/atoms/toaster";
import { useDebounceValue } from "usehooks-ts";
import IconButton from "@mui/material/IconButton";
import { X } from "@phosphor-icons/react/X";

export const useCheckoutPricing = (
	subscriptionsConfig: AccountSubscriptionPaidConfig,
	addressConfig?: Partial<Address>,
) => {
	const [debouncedPricingInput, setDebouncedPricingInput] = useDebounceValue(
		{
			// @ts-ignore partial also works
			address: addressConfig ?? {},
			subscriptions: [
				{
					quantity: 1,
					plan: getRecurlyPlan(subscriptionsConfig),
					addons: getRecurlyAddons(subscriptionsConfig),
				},
			],
		},
		250,
	);

	const [pricingError, setPricingError] = useState<RecurlyError | null>(null);
	const [pricing, setPricing] = useRecurlyCheckoutPricing({}, setPricingError);

	useEffect(() => {
		setDebouncedPricingInput({
			// @ts-ignore partial also works
			address: addressConfig ?? {},
			subscriptions: [
				{
					quantity: 1,
					plan: getRecurlyPlan(subscriptionsConfig),
					addons: getRecurlyAddons(subscriptionsConfig),
				},
			],
		});
	}, [subscriptionsConfig, addressConfig]);

	useEffect(() => {
		// @ts-ignore
		setPricing(debouncedPricingInput);

		// non stringify value keep triggering the effect
	}, [JSON.stringify(debouncedPricingInput)]);

	useEffect(() => {
		if (pricingError) {
			const toastId = toast.error(pricingError.message, {
				duration: Infinity,
				dismissible: true,
				richColors: true,
				cancel: (
					<IconButton
						sx={{
							marginLeft: "var(--toast-button-margin-start)",
							marginRight: "var(--toast-button-margin-end)",
						}}
						size="small"
						onClick={() => toast.dismiss(toastId)}>
						<X />
					</IconButton>
				),
			});
		}
	}, [pricingError]);

	return { pricing, pricingError };
};
